import { NuxtCookies } from 'cookie-universal-nuxt'
import { Store } from 'vuex'
import { RootState } from '@/store'
import * as types from '@/store/hospital/types'
import HospitalEntity, { IHospitalProps } from '@/entities/Hospital'
import { IResponseProps } from '@/entities/Response'

export default class HospitalRepository {
  private cookies: NuxtCookies
  private store: Store<RootState>

  constructor(cookies: NuxtCookies, store: Store<RootState>) {
    this.cookies = cookies
    this.store = store
  }

  set data(value: IResponseProps<IHospitalProps>) {
    this.store.commit(new types.Store(value))
  }

  get data(): IResponseProps<IHospitalProps> {
    return this.store.state.hospital.response
  }

  set current(value: IHospitalProps | null) {
    this.store.commit(new types.Current(value))
  }

  get current(): IHospitalProps | null {
    return this.store.state.hospital.current
  }

  get entity(): HospitalEntity {
    return new HospitalEntity(this.store.state.hospital.current)
  }

  set filter(value: string) {
    this.store.commit(new types.Filter(value))
  }

  get filter(): string {
    return this.store.state.hospital.filter
  }
}
